export default __webpack_public_path__ + "static/media/michel-deckert.5e9e725b.jpg";